import { useState, useEffect } from 'react'
import { GovernedClientsService, type GovernedClientsQuery } from '../services/governedClients'
import type { GovernedClientsResponse, GovernedClient } from '../types'

interface UseGovernedClientsReturn {
  clients: GovernedClient[]
  loading: boolean
  error: Error | null
  refetch: () => Promise<void>
  response: GovernedClientsResponse | null
}

export const useGovernedClients = (query: GovernedClientsQuery = {}): UseGovernedClientsReturn => {
  const [clients, setClients] = useState<GovernedClient[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const [response, setResponse] = useState<GovernedClientsResponse | null>(null)

  const fetchClients = async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await GovernedClientsService.getGovernedClients(query)
      setResponse(data)
      setClients(data.data)
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch governed clients'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchClients()
  }, [JSON.stringify(query)])

  return {
    clients,
    loading,
    error,
    refetch: fetchClients,
    response
  }
}